var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.98 31.11a11.46 11.46 0 01-1.98.347v2.508a13.953 13.953 0 002.837-.498l-.857-2.357zm2.737 1.673c.883-.395 1.718-.88 2.494-1.442l-1.612-1.921c-.547.384-1.13.72-1.74 1.006l.858 2.357zm5.878-4.934a14.068 14.068 0 01-1.853 2.206l-1.612-1.921a11.55 11.55 0 001.292-1.54l2.172 1.255zm1.001-1.731c.417-.857.75-1.764.986-2.708l-2.47-.435a11.427 11.427 0 01-.688 1.889l2.172 1.254zM19 6c7.041 0 12.868 5.198 13.853 11.966L35 17l-3.333 4L28 17l2.317.948C29.35 12.576 24.651 8.5 19 8.5 12.649 8.5 7.5 13.649 7.5 20c0 6.014 4.617 10.95 10.5 11.457v2.508C10.735 33.452 5 27.395 5 20c0-7.732 6.268-14 14-14zm-1 7l1-2.5 1 2.5v6l3 3 1 2.5-2.5-1L18 20v-7z",
    fill: "#9A9CAC"
  })));
}

export default SvgRecentIcon;